<div class="wm-form"
    *ngIf="liveWidgetSettingsService.selectedPropertyGroup.name === 'basic' && liveWidgetSettingsService.activeTab.type === 'fields'"
    [ngClass]='{"disabled" : !liveWidgetSettingsService.selectedComponent.field.pcDisplay &&  !liveWidgetSettingsService.selectedComponent.field.mobileDisplay}'>
    <div class="dialog-form-section">
        <!--Field-->
        <!--Field, Type, DisplayName-->
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_BINDING_FIELD}}</label>
            <label class="control-label app-label"
                *ngIf="!liveWidgetSettingsService.selectedComponent.field.allowBinding">{{liveWidgetSettingsService.selectedComponent.field.key
                || liveWidgetSettingsService.selectedComponent.field.field}}</label>
            <div class="form-control wms-typeahead-live-filter"
                *ngIf="(liveWidgetSettingsService.designerType === 'LIVEFORM' || liveWidgetSettingsService.designerType === 'FORM') && liveWidgetSettingsService.selectedComponent.field.allowBinding">
                <wms-typeahead name="wms-binding-column"
                    [ngClass]="{'invalid-input': liveWidgetSettingsService.selectedComponent.field.duplicateField}"
                    [editable]="true"
                    (onSelect)="liveWidgetSettingsService.onMappedFieldChange(liveWidgetSettingsService.selectedComponent.field, 'key', 'displayname', $event)"
                    [model]="liveWidgetSettingsService.selectedComponent.field.key"
                    [options]="liveWidgetSettingsService.fieldsList"
                    [modelType]="'string'">
                </wms-typeahead>
            </div>

            <div class="form-control wms-typeahead-live-filter"
                *ngIf="liveWidgetSettingsService.designerType === 'LIVEFILTER' && liveWidgetSettingsService.selectedComponent.field.allowBinding">
                <wms-typeahead name="wms-binding-column"
                    [ngClass]="{'invalid-input': liveWidgetSettingsService.selectedComponent.field.duplicateField}"
                    [editable]="true"
                    (onSelect)="liveWidgetSettingsService.onMappedFieldChange(liveWidgetSettingsService.selectedComponent.field, 'field', 'displayname', $event)"
                    [model]="liveWidgetSettingsService.selectedComponent.field.field"
                    [options]="liveWidgetSettingsService.fieldsList" [modelType]="'string'">
                </wms-typeahead>
            </div>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_BINDING_FIELD}}"
            class="wms wms-help"></i>
            <p class="row help-block col-md-9 col-md-push-3"
                *ngIf="liveWidgetSettingsService.selectedComponent.field.duplicateField">
                {{locale.HELP_MESSAGE_WIDGET_DESIGNER_DUPLICATE_FIELD}}
            </p>
        </div>
        <!--Type-->
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_FIELD_TYPE}}</label>
            <label class="control-label app-label"
                *ngIf="!liveWidgetSettingsService.selectedComponent.field.allowBinding">{{liveWidgetSettingsService.selectedComponent.field.type
                || 'none'}}</label>
            <div class="form-control wms-typeahead-live-filter"
                *ngIf="liveWidgetSettingsService.selectedComponent.field.allowBinding">
                <wms-typeahead [placeholder]="locale.LABEL_WIDGET_DESIGNER_FIELD_TYPE" name="wms-live-type"
                    [model]="liveWidgetSettingsService.selectedComponent.field.type"
                    [options]="liveWidgetSettingsService.definedTypes" [modelType]="'string'"
                    (onSelect)="liveWidgetSettingsService.onSelectedCompChange('field', 'type', $event);"
                > </wms-typeahead>
            </div>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_FIELD_TYPE}}"
                class="wms wms-help"></i>
        </div>

        <div class="form-group app-composite-widget clearfix"
            *ngIf="!liveWidgetSettingsService.selectedComponent.field.isRelated && liveWidgetSettingsService.designerType !== 'FORM'">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_FILTER_ON_FIELD}}</label>
            <div class="form-control wms-typeahead-live-filter">
                <wms-typeahead [placeholder]="locale.LABEL_SEARCH_LIVE_FILTER_FIELD" name="wms-live-filter"
                    [model]="liveWidgetSettingsService.selectedComponent.field.filterOn"
                    (onSelect)="liveWidgetSettingsService.onSelectedCompChange('field', 'filterOn', $event.value);"
                    [options]="liveWidgetSettingsService.filterFields"
                    [disable]="liveWidgetSettingsService.selectedComponent.field.dataset || !liveWidgetSettingsService.isDatasetWidgets[liveWidgetSettingsService.selectedComponent.field.displaywidget]">
                </wms-typeahead>
            </div>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_FILTER_ON_FIELD}}"
             class="wms wms-help"></i>
        </div>
        <div class="form-group app-composite-widget clearfix"
            *ngIf="((liveWidgetSettingsService.designerType === 'LIVEFILTER' && liveWidgetSettingsService.selectedComponent.field.type === 'string') || (liveWidgetSettingsService.designerType === 'LIVEFORM' && liveWidgetSettingsService.relatedColumnObject[liveWidgetSettingsService.selectedComponent.field.key]))">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_MATCH_MODE}}</label>
            <select class="form-control app-select"
                [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.matchmode">
                <option *ngFor="let option of matchModes | keyvalue" [value]="option.key">{{option.value}}</option>
            </select>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_MATCH_MODE}}"
                class="wms wms-help"></i>
        </div>
        <h5 class="dialog-body-sub-heading">
            {{locale.LABEL_DISPALY_PROPERTIES}}
        </h5>
        <!--widget type-->
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDGET}}</label>
            <select [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.displaywidget"
                    [ngModelOptions]="{updateOn: 'change'}"
                (ngModelChange)="onWidgetTypeChange(liveWidgetSettingsService.selectedComponent.field)"
                class="form-control app-select" placeholder="locale.LABEL_WIDGET_DESIGNER_WIDGET_TYPE" role="input">
                <optgroup label="{{locale.LABEL_PREFERRED}}">
                    <option
                        *ngFor="let widget of widgetTypeOptions"
                        [value]="widget">{{widget}}</option>
                </optgroup>
                <optgroup label="{{locale.LABEL_INSERT_OTHERS_TAB_TITLE}}">
                    <option *ngFor="let widget of otherWdgts"
                        [value]="widget">{{widget}}
                    </option>
                </optgroup>
            </select>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDGET}}" class="wms wms-help"></i>
            <p class="row help-block col-md-8 col-md-push-3"
                *ngIf="locale['HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_' + toUpperCase(liveWidgetSettingsService.selectedComponent.field.displaywidget)]">
                {{locale['HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_' +
                toUpperCase(liveWidgetSettingsService.selectedComponent.field.displaywidget)]}}
            </p>
        </div>
        <div class="form-group app-composite-widget clearfix"
            *ngIf="liveWidgetSettingsService.designerType === 'LIVEFILTER' && !liveWidgetSettingsService.hideRange[liveWidgetSettingsService.selectedComponent.field.type] && !liveWidgetSettingsService.hideRange[liveWidgetSettingsService.selectedComponent.field.displaywidget]">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_RANGE}}</label>
            <wms-toggle [hideLabels]="true" [model]="liveWidgetSettingsService.selectedComponent.field.isRange"  (onChange)="toToggle('isRange',$event)"></wms-toggle>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_RANGE}}"
                class="wms wms-help"></i>
        </div>
        <div
            *ngIf="liveWidgetSettingsService.designerType === 'LIVEFORM' && liveWidgetSettingsService.selectedComponent.field.type === 'list'">
            <div
                *ngIf="getVariableDetails()?.operation === 'read'
                        && liveWidgetSettingsService.selectedComponent.field.isRelated
                        && !liveWidgetSettingsService.selectedComponent.field.dataset
                        && liveWidgetSettingsService.isListWidget(liveWidgetSettingsService.selectedComponent.field.displaywidget)">
                <!--Filter Criteria-->
                <wms-criteria-builder [isDialog]="true"
                    [liveWidgetSettingsService]="liveWidgetSettingsService"
                    [filterFields]="liveWidgetSettingsService.relatedColumnObject[liveWidgetSettingsService.selectedComponent.field.key+'_columns']"
                    [filterExpressions]="liveWidgetSettingsService.selectedComponent.field.filterexpressions"
                   ></wms-criteria-builder>
            </div>
        </div>
        <div
            *ngIf="liveWidgetSettingsService.isDatasetWidgets[liveWidgetSettingsService.selectedComponent.field.displaywidget] && !liveWidgetSettingsService.selectedComponent.field.dataset && liveWidgetSettingsService.relatedColumnObject && liveWidgetSettingsService.relatedColumnObject[liveWidgetSettingsService.selectedComponent.field.key]">
            <div class="form-group app-composite-widget clearfix display-value">
                <label
                    class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_DISPLAYEXPRESSION}}</label>
                <textarea class="form-control app-textarea"
                    placeholder="Enter expression. Select from the list on the right"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.displayexpression"
                    [ngModelOptions]="{ updateOn: 'change' }"></textarea>
                <ul class="display-value-list">
                    <li class="item clearfix"
                        *ngFor="let column of liveWidgetSettingsService.relatedColumnObject[liveWidgetSettingsService.selectedComponent.field.key];index as $index"
                        (click)="liveWidgetSettingsService.populateDisplayValue(column, 'displayexpression')"
                        title="{{column}}">
                        <i class="wms wms-arrow-left"></i>
                        <span class="item-name">{{column}}</span>
                    </li>
                </ul>
                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_DISPLAYEXPRESSION}}"
                 class="wms wms-help"></i>
            </div>
            <div *ngIf="liveWidgetSettingsService.selectedComponent.field.displaywidget === 'autocomplete'">
                <div class="form-group app-composite-widget clearfix">
                    <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_SEARCHKEY}}</label>
                    <wm-checkboxset [datavalue]="liveWidgetSettingsService.selectedComponent.field.searchkey"
                        [dataset]="liveWidgetSettingsService.relatedColumnObject[liveWidgetSettingsService.selectedComponent.field.key]"
                        (onChange)="handelChangesSearchKey($event.value)"
                        datafield="value" displayfield="name">
                    </wm-checkboxset>
                    <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SEARCHKEY}}"
                        class="wms wms-help"></i>
                </div>
            </div>
        </div>
        <!--Order by selection for related fields-->
        <div
            *ngIf="liveWidgetSettingsService.isDatasetWidgets[liveWidgetSettingsService.selectedComponent.field.displaywidget] && !liveWidgetSettingsService.selectedComponent.field.dataset">
            <div class="form-group app-composite-widget clearfix"
                *ngIf="liveWidgetSettingsService.relatedColumnObject && liveWidgetSettingsService.relatedColumnObject[liveWidgetSettingsService.selectedComponent.field.key]">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_ORDERBY}}</label>
                <wms-order-by [orderbyModel]="liveWidgetSettingsService.selectedComponent.field.orderby"
                    [options]="liveWidgetSettingsService.relatedColumnObject[liveWidgetSettingsService.selectedComponent.field.key]"
                              (onChange)="liveWidgetSettingsService.onSelectedCompChange('field', 'orderby', $event.orderbyModel)"
                    group-fields="true"></wms-order-by>
                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_ORDERBY}}"
                    class="wms wms-help"></i>
            </div>
            <!--groupby-->
            <div class="form-group app-composite-widget clearfix"
                *ngIf="liveWidgetSettingsService.relatedColumnObject && liveWidgetSettingsService.relatedColumnObject[liveWidgetSettingsService.selectedComponent.field.key]">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_GROUPBY}}</label>
                <div class="form-control wms-typeahead-live-filter">
                    <wms-typeahead placeholder="{{locale.LABEL_PROPERTY_GROUPBY}}" name="wms-select-group"
                        [modelType]="'string'"
                        [propertyName]="'name'" [model]="liveWidgetSettingsService.selectedComponent.field.groupby"
                        [options]="liveWidgetSettingsService.relatedColumnObject[liveWidgetSettingsService.selectedComponent.field.key + '_groupByDisplayOptions']"
                        (onSelect)="liveWidgetSettingsService.onSelectedCompChange('field', 'groupby', $event); liveWidgetSettingsService.showOrHideMatchProperty()"
                        (onClear)="liveWidgetSettingsService.onClear()" groupBy="category" model-property-name="name">
                    </wms-typeahead>
                </div>

                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_GROUPBY}}" class="wms wms-help"></i>
                <p class="alert app-message alert-info" *ngIf="liveWidgetSettingsService.showGroupByActionMessage"><i
                        class="icon"></i>
                    <span
                        *ngIf="liveWidgetSettingsService.showGroupByActionMessage">{{locale.MESSAGE_CUSTOM_SCRIPT_CREATED}}<a
                            style='cursor:pointer' (click)='liveWidgetSettingsService.saveDesignerSettings(true)'>
                            {{locale.LABEL_CLICK_HERE_TO_EDIT}}</a></span>
                </p>
            </div>
            <!--group as-->
            <div class="form-group app-composite-widget clearfix"
                *ngIf="liveWidgetSettingsService.selectedComponent.field.showMatch">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_MATCH}}</label>
                <select class="form-control app-select" placeholder="locale.LABEL_PROPERTY_MATCH" role="input"
                    (ngModelChange)="liveWidgetSettingsService.showOrHideMatchProperty()"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.match">
                    <option value="{{nonGroupOpt.value}}"
                        *ngFor="let nonGroupOpt of liveWidgetSettingsService.timeNonGroupOptions; index as $index">{{locale[nonGroupOpt.labelkey]}}
                        </option>
                    <optgroup label="{{locale.LABEL_TIME}}"
                        *ngFor="let optVal of liveWidgetSettingsService.timeGroupOptions; index as $index">
                        <option value="{{item.key}}"
                            *ngFor="let item of optVal.groupOptions | keyvalue ; index as $index">
                            {{item.key}}</option>
                    </optgroup>
                </select>

                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_MATCH}}" class="wms wms-help"></i>
            </div>
            <!--dateformat-->
            <div class="form-group app-composite-widget clearfix"
                *ngIf="liveWidgetSettingsService.selectedComponent.field.showDateFormat">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_DATEFORMAT}}</label>
                <datalist id="datePatternsList">
                    <option
                        *ngFor="let pattern of liveWidgetSettingsService.datePatterns  | keyvalue | orderBy:'value'">
                        {{pattern.value}}</option>
                </datalist>
                <input class="form-control app-textbox"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.dateformat" list="datePatternsList"
                    placeholder="{{locale.MESSAGE_PLACEHOLDER_PATTERN}}" />

                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_DATEFORMAT}}" class="wms wms-help"></i>
            </div>
            <!--collapsible-->
            <div class="form-group app-composite-widget clearfix"
                *ngIf="liveWidgetSettingsService.selectedComponent.field.showCollapsible">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_COLLAPSIBLE}}</label>
                <wms-toggle [hideLabels]="true" [model]="liveWidgetSettingsService.selectedComponent.field.collapsible"></wms-toggle>
                <i -placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_COLLAPSIBLE}}" class="wms wms-help"></i>
            </div>

            <!--show count-->
            <div class="form-group app-composite-widget clearfix"
                *ngIf="liveWidgetSettingsService.selectedComponent.field.showCount">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_SHOWCOUNT}}</label>
                <wms-toggle [hideLabels]="true" [model]="liveWidgetSettingsService.selectedComponent.field.showcount"></wms-toggle>
                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_SHOWCOUNT}}" class="wms wms-help"></i>
            </div>

        </div>

        <!--Conditional Column Classes-->
        <div class="form-group app-composite-widget clearfix">
            <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_CONDITIONAL_CLASS}}</label>
            <div class="conditional-classes-container">
                <div
                    *ngFor="let cls of liveWidgetSettingsService.selectedComponent.field.ngClasses; first as $first; last as $last">
                    <input type="text" [(ngModel)]="cls.className" [ngModelOptions]="{updateOn: 'blur'}"
                        class="form-control app-textbox conditional-classname" [ngClass]="{'error': cls.error?.class}"
                        placeholder="{{locale.LABEL_CLASS_NAME}}"
                        (ngModelChange)="liveWidgetSettingsService.validateAndUpdateNgClasses(cls);" />
                    <input type="text" [(ngModel)]="cls.condition" [ngModelOptions]="{updateOn: 'blur'}"
                        [ngClass]="{'error': cls.error?.condition}"
                        class="form-control app-textbox conditional-expression"
                        placeholder="{{locale.PLACEHOLDER_DESIGNER_CONDITION_EXPRESSION}}"
                        (ngModelChange)="liveWidgetSettingsService.validateAndUpdateNgClasses(cls);" />
                    <button type="button" title="{{locale.LABEL_WIDGET_DESIGNER_REMOVE_CONDITION}}"
                        class="btn btn-secondary conditional-class-remove-btn"
                        (click)="liveWidgetSettingsService.removeConditionalClass('field',cls)">
                        <i class="wm-icon12 wms wms-delete"></i>
                    </button>
                    <button type="button" title="{{locale.LABEL_WIDGET_DESIGNER_ADD_CONDITIONAL_CLASS}}"
                        class="btn btn-secondary conditional-class-add-btn" *ngIf="$last"
                        (click)="liveWidgetSettingsService.addConditionalClass(cls, liveWidgetSettingsService.selectedComponent.field)">
                        <i class="wm-icon12 wms wms-plus"></i>
                    </button>
                    <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_COLUMN_CONDITIONAL_CLASS}}"
                        class="wms wms-help" *ngIf="$first"></i>
                    <p class="row help-block error" *ngIf="cls.errorMsg">{{cls.errorMsg}}</p>
                </div>
            </div>
        </div>
        <div
            *ngIf="liveWidgetSettingsService.designerType === 'LIVEFILTER' && liveWidgetSettingsService.selectedComponent.field.isRelated">
            <h5 class="dialog-body-sub-heading">
                {{locale.LABEL_LOOK_UP_DATA}}
            </h5>

            <!--Table Name-->
            <div class="form-group app-composite-widget clearfix">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_TYPE}}</label>
                <select class="form-control app-select"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.lookupType">
                    <option *ngFor="let option of liveWidgetSettingsService.selectedComponent.field.lookupTypeOptions "
                        [value]="option">{{option}}</option>
                </select>
                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_TYPE}}"
                    class="wms wms-help"></i>
            </div>
            <!--Column Name-->
            <div class="form-group app-composite-widget clearfix">
                <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_FIELD}}</label>
                <select class="form-control app-select"
                    [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.lookupField"
                    (change)="liveWidgetSettingsService.onLookupChange(liveWidgetSettingsService.selectedComponent.field)">
                    <option *ngFor="let option of liveWidgetSettingsService.selectedComponent.field.lookupFieldOptions "
                        [value]="option">{{option}}</option>
                </select>
                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_FIELD}}" class="wms wms-help"></i>
            </div>
            <div
                *ngIf="liveWidgetSettingsService.activeWidgetScope.variableObj?.operation === 'read'
                        && !liveWidgetSettingsService.selectedComponent.field.dataset
                        && liveWidgetSettingsService.isListWidget(liveWidgetSettingsService.selectedComponent.field.displaywidget)">
                <!--Filter Criteria-->
              <wms-criteria-builder [isDialog]="true" [liveWidgetSettingsService]="liveWidgetSettingsService"
                                    [filterFields]="liveWidgetSettingsService.relatedData[liveWidgetSettingsService.selectedComponent.field.relatedEntityName]['criteriaFilterFields']"
                                    [filterExpressions]="liveWidgetSettingsService.selectedComponent.field.filterexpressions"
                                    (onChange)="this.liveWidgetSettingsService.onSelectedCompChange('field', 'filterexpressions', $event)">
              </wms-criteria-builder>
            </div>
        </div>
    </div>
</div>
<wms-dialog id="WmsCriteriaBuilderDialog" [content]="criteriaBuilderDialog" customClasses="query-dialog add-new-variable-container-dialog large wm-studio-dialog"></wms-dialog>
<ng-template #criteriaBuilderDialog>
  <wms-dialog-header title="{{locale.LABEL_FILTER_CRITERIA}}" name="wm-add-variable-dialog" [showClose]="false" helpLink="_blank"
                     helpTitle="{{locale['MESSAGE_HELP_VARIABLE']['wm.LiveVariable']['HEADER_HELP_TEXT']['FILTERFIELDS']}}"></wms-dialog-header>
  <wms-dialog-body>
    <div class="secondary-panel">
      <wms-criteria-builder [liveWidgetSettingsService]="liveWidgetSettingsService"
                            [filterFields]="liveWidgetSettingsService.designerType === 'LIVEFILTER' ? liveWidgetSettingsService.relatedData[liveWidgetSettingsService.selectedComponent.field.relatedEntityName]['criteriaFilterFields'] :
                            liveWidgetSettingsService.relatedColumnObject[liveWidgetSettingsService.selectedComponent.field.key+'_columns']"
                            [filterExpressions]="liveWidgetSettingsService.selectedComponent.field.filterexpressions"
                            (onChange)="this.liveWidgetSettingsService.onSelectedCompChange('field', 'filterexpressions', $event)">
      </wms-criteria-builder>
    </div>
  </wms-dialog-body>
  <wms-dialog-footer>
    <button name="wm-addvariable-cancel_close" (click)="onCancel('WmsCriteriaBuilderDialog')"
            [attr.disabled]="" class="btn app-button">{{locale.LABEL_CANCEL}}</button>
    <button name="wm-addvariable-save_close" (click)="onSaveClose('WmsCriteriaBuilderDialog')"
            [attr.disabled]="" class="btn app-button button-primary">{{locale.LABEL_DONE}}</button>
  </wms-dialog-footer>
</ng-template>
